<template>
  <layer pagename="condition" pageClass="conditionPage">
    <div class="left">
      <patientList :id="id" isPrescription />
    </div>
    <div class="center">
      <prescription-entry
        v-if="info"
        pageType
        :info="info"
        :quoteDurgList="drugList"
      />
      <empty v-else text="无用户信息" />
      <!-- 右下解引用悬浮按钮菜单 -->
      <float-menu v-if="hideAi" :info="info" />
    </div>
    <div class="right" v-if="info">
      <medicalRecordList
        isPrescriptionPage
        v-if="showMedicalRecordList"
        :info="info"
        :patientCode="info.patientCode"
        @quote="quote"
        :symptomNo="info.symptomNo"
      />
      <empty v-else text="无用户信息" />
    </div>
  </layer>
</template>

<script>
import patientList from "@/com/patientList.vue";
import medicalRecordList from "@/com/medicalRecordList.vue";
import PrescriptionEntry from "@/com/prescriptionEntry.vue";
import { mapGetters } from "vuex";
export default {
  props: {
    id: {
      type: String,
      default: "",
    },
  },
  components: {
    patientList,
    medicalRecordList,
    PrescriptionEntry,
  },
  computed: {
    ...mapGetters([
      "hideAi",
      "prescribeRegisterList", // 就诊中及未就诊挂号(处方单)
    ]),
  },
  watch: {
    prescribeRegisterList(newValue, oldValue) {
      if (
        !this.common.inArray(
          [newValue.Visit.details, oldValue.Visit.details],
          this.id
        )
      ) {
        this.init();
      } else {
        let item1 = newValue.Visit.details.find(
          (i) => i.registerCode == this.id
        );
        let item2 = oldValue.Visit.details.find(
          (i) => i.registerCode == this.id
        );
        if (item1.prescriptionNo != item2.prescriptionNo) {
          this.init();
        }
      }
    },
    id() {
      this.init();
    },
  },
  data() {
    return {
      drugList: [],
      info: null,
      showMedicalRecordList: false,
    };
  },
  methods: {
    quote(drugList) {
      this.drugList = drugList;
      this.$bus.emit("quotingPrescriptions");
    },
    init() {
      this.showMedicalRecordList = false;
      setTimeout(() => {
        this.showMedicalRecordList = true;
      }, 100);
      let list = this.prescribeRegisterList.Visit.details;
      this.info = list.find((i) => i.registerCode == this.id);
    },
  },
  created() {
    this.init();
  },
};
</script>

<style lang="scss" scoped>
.u_content {
  display: flex;
  height: 100%;
  min-height: 0;
}
.center{
  position: relative;
}
</style>